<template lang="pug">
  v-content
    v-container
      v-toolbar.elevation-1(card color='white')
        v-toolbar-title Edit Memo
        v-spacer
        v-btn(color="green" dark v-if="$route.path == '/im-budget'" href='https://drive.google.com/drive/folders/1znvp8X3Pr7XB5fWf7GLSi52j2MUPrCfo' target="_blank") SOP
        v-dialog(v-if="$route.name == 'Edit IM Budget' || $route.name == 'Edit IM Proposal Investasi'" v-model="dialog" width="900px")
          template(v-slot:activator="{ on }")
            v-btn(color="green" dark v-on="on") MLA Reference
          v-card
            v-card-text
              v-img(src="img/mla.png")
            v-card-actions
              v-spacer 
              v-btn(color="green darken-1" flat="flat" @click="dialog = false") Close
        v-btn(v-if="$route.name !== 'Edit IM Forex' && $route.name !== 'Edit Document Legal F1' && $route.name !== 'Edit Document Legal F2'" color='blue-secondary' to='/my-request') LIST MEMO
      WizardNonBudget(v-if="$route.name === 'Edit Memo'" edit)
      WizardNonBudget(v-if="$route.name === 'Edit Internal Memo'" edit)
</template>

<script>
import WizardNonBudget from "../components/WizardNonBudget.vue";
export default {
  name: "EditForm",
  components: {
    WizardNonBudget
  },
  data () {
    return {
      dialog: false
    }
  },
  mounted() {
    if(this.$route.name === 'Edit IM Forex') {
      this.$store.dispatch("fetchForexEditRequests", this.$route.params.id);
    } else if(this.$route.name === 'Edit Document Legal F1' || this.$route.name === 'Edit Document Legal F2') {
      this.$store.dispatch("fetchLegalEditRequests", this.$route.params.id);
    } else {
      this.$store.dispatch("fetchDataEditRequests", this.$route.params.id);
    }
  }
};
</script>